import React from 'react';
import styled from 'styled-components';

import { ProductCardTextAlignmentOption } from 'types/graphql';
import { PreviewData } from '../components/preview';

type ProductCardPreviewProps = {
  data: PreviewData;
};

export const ProductCardPreview = ({ data }: ProductCardPreviewProps): JSX.Element => {
  const { textAlignment, showProductWeight } = data.productCards;

  let cardImage = '';

  if (textAlignment === ProductCardTextAlignmentOption.center) {
    cardImage = showProductWeight ? 'card-preview-weight-center.png' : 'card-preview-no-weight-center.png';
  } else {
    cardImage = showProductWeight ? 'card-preview-weight-v2.png' : 'card-preview-no-weight.png';
  }

  return (
    <Container>
      <figure>
        <Caption>Card View</Caption>
        <Image src={`https://images.dutchie.com/product-cards/${cardImage}`} alt='Card View Preview' width={184} />
      </figure>
      <figure>
        <Caption>List View</Caption>
        <Image src='https://images.dutchie.com/product-cards/list-preview-v2.png' alt='List View Preview' width={346} />
      </figure>
    </Container>
  );
};

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const Caption = styled.figcaption`
  font-size: 12px;
  line-height: ${18 / 12};
  margin-bottom: 8px;
  text-align: center;
`;
